import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDown, Paperclip } from 'lucide-react';
import { VslPlayer } from './VslPlayer';
import { HERO_IMAGE as BIBLE_COVER } from '../utils/resourceHints';
export function CaseCover() {
  return <section aria-labelledby="portada-titulo" className="relative border-b border-white/[0.07] px-5 pb-10 pt-8 sm:px-10 sm:pb-14 sm:pt-12 lg:px-14 lg:pb-20 lg:pt-16" data-id="element-1" data-mp="3j7zoof0fciz3">
      <motion.span initial={{
      opacity: 0,
      scale: 2.4,
      rotate: -18
    }} animate={{
      opacity: 1,
      scale: 1,
      rotate: -10
    }} transition={{
      duration: 0.7,
      delay: 0.55,
      ease: [0.22, 1, 0.36, 1]
    }} className="absolute right-4 top-4 z-20 rounded border-2 border-double border-signal-pink bg-ink/60 px-2 py-1 text-[9px] font-extrabold tracking-[0.14em] text-signal-pink [text-shadow:0_0_10px_rgba(255,47,146,0.5)] sm:right-10 sm:top-8 sm:border-[3px] sm:px-3 sm:py-1.5 sm:text-[13px] lg:right-14" data-id="element-2" data-mp="fqpui1olmlax">
        TOP SECRET
      </motion.span>

      <div className="grid items-center gap-8 sm:gap-10 lg:grid-cols-[1.2fr_0.8fr] lg:gap-12" data-id="element-3" data-mp="rdhowmc989ji">
        <div className="max-w-[42rem]" data-id="element-4" data-mp="ncny9l7fggmx">
          <motion.div initial={{
          opacity: 0,
          y: 14
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55
        }} className="flex flex-wrap items-center gap-x-3 gap-y-1 font-mono text-[9.5px] uppercase tracking-[0.14em] text-ash" data-id="element-5" data-mp="ndz4rss9c2hq">
            <span className="font-bold text-gold" data-id="element-6" data-mp="1b0npem8ni921">Expediente 00 · Portada</span>
            <span aria-hidden="true" data-id="element-7" data-mp="163ox898jsc6h">·</span>
            <span data-id="element-8" data-mp="165026cdqbpz6">The Visual Disruption Bible 2.0</span>
            <span aria-hidden="true" data-id="element-9" data-mp="1k2wxl5gg5qc9">·</span>
            <span data-id="element-10" data-mp="1k0kj529wdy3y">Sistema de Armamento Visual</span>
          </motion.div>

          <motion.h1 id="portada-titulo" initial={{
          opacity: 0,
          y: 26
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.75,
          delay: 0.1
        }} className="mt-3 font-display text-[1.65rem] font-bold leading-[1.16] tracking-tight text-bone sm:mt-5 sm:text-[2.5rem] lg:text-[2.9rem]" data-id="element-11" data-mp="1f43lnhgt67e7">
            Cómo Dominar la IA Visual, Romper el Algoritmo y Generar Visuales que
            Parecen Producidos por una{' '}
            <span className="italic gold-text" data-id="element-12" data-mp="1uox1t5k7qy0w">Agencia de $50,000</span>...
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.22
        }} className="mt-3.5 max-w-[34rem] text-[14.5px] leading-relaxed text-ash sm:mt-5 sm:text-base" data-id="element-13" data-mp="1ysmotql8p7jt">
            En menos de 10 segundos, sin saber editar y sin gastar una fortuna en
            software.
          </motion.p>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.5
        }} className="mt-6 flex items-center gap-3 font-mono text-[9.5px] uppercase tracking-[0.16em] text-ash sm:mt-9 sm:text-[10px]" data-id="element-14" data-mp="2ie9b05fjj637">
            <ArrowDown aria-hidden="true" className="h-4 w-4 animate-bob text-gold" data-id="element-15" data-mp="ftou1af4ohw2" />
            Desclasificando expediente · 8 folios
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30,
        rotate: -4
      }} animate={{
        opacity: 1,
        y: 0,
        rotate: -1.5
      }} transition={{
        duration: 0.9,
        delay: 0.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative mx-auto w-[12.5rem] sm:w-[15rem] lg:w-[17rem]" data-id="element-16" data-mp="6rpc8fwah9s2">
          <span aria-hidden="true" className="absolute -top-3 left-1/2 z-20 -translate-x-1/2 text-white/60" data-id="element-17" data-mp="uh9vz109ob2e">
            <Paperclip className="h-7 w-7 rotate-12" data-id="element-18" data-mp="ppibn87pf1kp" />
          </span>
          <div aria-hidden="true" className="absolute inset-0 -z-10 rounded-full bg-[radial-gradient(circle,rgba(212,175,55,0.3),transparent_70%)] blur-2xl" data-id="element-19" data-mp="kqxddec0iryw" />
          <div className="rounded-md bg-white p-2 shadow-[0_26px_60px_rgba(0,0,0,0.7)]" data-id="element-20" data-mp="1dge0pxkrzio9">
            <img src={BIBLE_COVER} alt="Portada de The Visual Disruption Bible 2.0" width={899} height={1200} fetchPriority="high" decoding="async" className="h-auto w-full rounded-sm" data-id="element-21" data-mp="x0n1to79x463" />
          </div>
          <p className="mt-3 text-center font-mono text-[9px] uppercase tracking-[0.16em] text-white/35" data-id="element-22" data-mp="syrtw0uu7sjc">
            Prueba A · Documento maestro
          </p>
        </motion.div>
      </div>

      <VslPlayer data-id="element-23" data-mp="1kqz6mq782ksg" />
    </section>;
}